<div
    class="flex-row flex-center flex-middle u-spacing-xl-pv u-spacing-3xl-pb u-spacing-lg-pt"
    style="width: 100%; height: 100%"
>
    <div class="flex-col flex-center u-spacing-2xl-pt" style="height: 100%; width: 672px; max-width: 1200px">
        <div class="u-spacing-md-pv u-spacing-xl-ph" style="width: 100%; height: fit-content">
            <div class="u-spacing-xl-pv" style="width: 100%; height: fit-content">
                <img
                    src="/assets/kempower-page-not-found-icon.svg"
                    alt="Page not found icon"
                    class="u-spacing-xl-mb u-size-10xl-w u-size-10xl-h"
                />
                <div class="flex-row flex-center flex-middle">
                    <div class="flex-col flex-center">
                        <h2 class="Title u-text-title-md u-text-align-center u-spacing-md-mb u-color-text-secondary">
                            Sorry, nothing found here...
                        </h2>
                        <p class="SupportingText u-text-align-center u-text-body-md u-color-text-secondary">
                            The page you're looking for doesn't exist. Return to the
                            <a href="/logs/">event log lookup</a> to retrieve a charger's CTEP event log.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
